import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { MotivoRechazoService } from '../../../services/MotivoRechazoService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'rechazo_motivo',
    label: 'Clave',
    type: 'text',
    col: 4,
    placeholder: 'Ej. MR-01',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'rechazo_motivo_nombre',
    label: 'Descripción',
    type: 'text',
    col: 8,
    placeholder: 'Descripción del rechazo',
    validators: [
      Validators.required("La descripción es obligatoria")
    ],
  },
];

export const MotivoRechazoForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await MotivoRechazoService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await MotivoRechazoService.guardar(values);
  };

  return (
    <CatalogForm
      title="Motivo de Rechazo"
      subtitle="Causales de rechazo de mercancía o servicios"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/MotivosRechazo"
    />
  );
};

export default MotivoRechazoForm;
